(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oudamir-header"]) return;
  try {
    
  class OudamirHeader extends HTMLElement {
    constructor() {
      super();
      this.header = this.querySelector('.oudamir-hdr');
      this.threshold = parseInt(this.dataset.scrollThreshold) || 80;
      this.scrolled = false;

      this.hamburger = this.querySelector('.oudamir-hdr__hamburger');
      this.drawer = this.querySelector('.oudamir-drawer');
      this.overlay = this.querySelector('.oudamir-drawer-overlay');
      this.closeBtn = this.querySelector('.oudamir-drawer__close');
    }

    connectedCallback() {
      this.isHomepage = this.dataset.isHomepage === 'true';

      /* Separate announcement bar from header in the wrapper */
      this._setupLayers();

      /* Measure once and set body spacer */
      this._setBodySpacer();
      window.addEventListener('resize', () => this._setBodySpacer(), { passive: true });

      /* Template-based scroll logic */
      if (this.isHomepage) {
        /* Homepage: enable scroll animation */
        this._onScroll = this._handleScroll.bind(this);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._handleScroll();
      } else {
        /* Inner pages: apply .is-scrolled immediately, no scroll listener */
        if (this.headerWrapper) this.headerWrapper.classList.add('is-scrolled');
      }

      /* Drawer */
      if (this.hamburger) this.hamburger.addEventListener('click', () => this._openDrawer());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this._closeDrawer());
      if (this.overlay) this.overlay.addEventListener('click', () => this._closeDrawer());

      /* Currency dropdowns */
      this._initCurrencySelectors();

      /* Language switcher */
      this._initLanguageSwitchers();
    }

    disconnectedCallback() {
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
    }

    /**
     * Separates announcement bar and header into two layers:
     * 1. Announcement bar → gets .oudamir-announcement-bar class (own fixed layer)
     * 2. Header section → wrapped in .oudamir-header-group (separate fixed layer below)
     */
    _setupLayers() {
      /* If already set up, just grab references */
      if (document.querySelector('.oudamir-header-group')) {
        this.headerWrapper = document.querySelector('.oudamir-header-group');
        return;
      }

      const allSections = document.querySelectorAll('.shopify-section-group-header-group');
      if (allSections.length === 0) return;

      let announcementSection = null;
      let headerSection = null;

      allSections.forEach(function (section) {
        if (
          section.classList.contains('announcement-bar-section') ||
          section.querySelector('.announcement-bar') ||
          section.querySelector('.utility-bar')
        ) {
          announcementSection = section;
        } else {
          headerSection = section;
        }
      });

      /* Tag the announcement bar section */
      if (announcementSection) {
        announcementSection.classList.add('oudamir-announcement-bar');
      }

      /* Wrap ONLY the header section in .oudamir-header-group */
      if (headerSection) {
        const wrapper = document.createElement('div');
        wrapper.className = 'oudamir-header-group';
        wrapper.setAttribute('data-homepage', this.isHomepage ? 'true' : 'false');
        headerSection.parentNode.insertBefore(wrapper, headerSection);
        wrapper.appendChild(headerSection);
        this.headerWrapper = wrapper;
      }
    }

    /**
     * Measure total fixed height (announcement + header) for body padding.
     */
    _setBodySpacer() {
      const announcement = document.querySelector('.oudamir-announcement-bar');
      const aH = announcement ? announcement.offsetHeight : 0;
      const hH = this.headerWrapper ? this.headerWrapper.offsetHeight : 0;
      document.documentElement.style.setProperty('--oudamir-header-group-height', aH + hH + 'px');
    }

    /**
     * Homepage scroll handler — ONLY toggles .is-scrolled class.
     */
    _handleScroll() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      if (scrollY > this.threshold && !this.scrolled) {
        this.scrolled = true;
        if (this.headerWrapper) this.headerWrapper.classList.add('is-scrolled');
      } else if (scrollY <= this.threshold && this.scrolled) {
        this.scrolled = false;
        if (this.headerWrapper) this.headerWrapper.classList.remove('is-scrolled');
      }
    }

    _openDrawer() {
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    _closeDrawer() {
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    _initCurrencySelectors() {
      const self = this;

      this.querySelectorAll('.oudamir-currency').forEach(function (wrapper) {
        const trigger = wrapper.querySelector('.oudamir-currency__trigger');
        const dropdown = wrapper.querySelector('.oudamir-currency__dropdown');
        if (!trigger || !dropdown) return;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const isOpen = dropdown.classList.contains('is-open');
          /* Close ALL dropdowns first */
          self._closeAllCurrencyDropdowns();

          if (!isOpen) {
            trigger.setAttribute('aria-expanded', 'true');
            dropdown.setAttribute('aria-hidden', 'false');
            dropdown.classList.add('is-open');
          }
        });

        /* Country option click → handled by oudamir-currency-converter.js */
        /* No form submission needed — display-only conversion */
      });

      /* Close on outside click */
      document.addEventListener('click', function () {
        self._closeAllCurrencyDropdowns();
      });
    }

    _closeAllCurrencyDropdowns() {
      this.querySelectorAll('.oudamir-currency').forEach(function (wrapper) {
        var trigger = wrapper.querySelector('.oudamir-currency__trigger');
        var dropdown = wrapper.querySelector('.oudamir-currency__dropdown');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (dropdown) {
          dropdown.setAttribute('aria-hidden', 'true');
          dropdown.classList.remove('is-open');
        }
      });
    }

    _initLanguageSwitchers() {
      this.querySelectorAll('.oudamir-lang').forEach(function (wrapper) {
        wrapper.querySelectorAll('.oudamir-lang__option').forEach(function (option) {
          option.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var code = option.dataset.langCode;
            var form = wrapper.querySelector('form');
            if (form) {
              var input = form.querySelector('input[name="locale_code"]');
              if (input) {
                input.value = code;
                form.submit();
              }
            }
          });
        });
      });
    }
  }

  customElements.define('oudamir-header', OudamirHeader);

  } catch(e) { console.error(e); }
})();
})();
